<template>
  <keep-alive :max="5">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
import '@/assets/css/app.css'
import 'video.js/dist/video-js.css'
import { mapActions } from 'vuex'

// set up ag-grid license
import { LicenseManager } from '@ag-grid-enterprise/core'
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-058035}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{The_E.W._Scripps_Company}_is_granted_a_{Multiple_Applications}_Developer_License_for_{6}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_June_2025}____[v3]_[01]_MTc0OTMzNzIwMDAwMA==2cbbbb77cd80dccd4db8e4a012de170c'
)

export default {
  /* eslint-disable */
  components: {},
  data() {
    return {
      ews_auth: {}
    }
  },
  created() {},
  methods: {
    ...mapActions(['authenticate'])
  }
}
</script>

<style lang="postcss">
@import '../node_modules/@videojs/themes/city/index.css';
@import '../node_modules/@ag-grid-community/styles/ag-grid.css';
@import '../node_modules/sweetalert2/dist/sweetalert2.min.css';
@import './assets/css/grid.css';

/* Extra CSS that needs tailwind apply functions */

.ag-root-wrapper {
}
.ag-header,
.ag-header-row {
  @apply h-10;
}
.ag-row {
  @apply h-10;
}
.ag-header {
  @apply bg-blue-500 text-blue-50 text-base outline-none;
}
.ag-header-cell {
  @apply font-semibold px-3 outline-none;
}
/* .ag-row {
  @apply hover:bg-blue-50 cursor-pointer;
} */
.ag-header-icon {
  @apply text-blue-300 px-1;
}
.ag-body-viewport {
  @apply bg-white;
}
.ag-cell {
  @apply p-1 border-t border-r border-gray-200 text-base font-medium;
}
.ag-center-cols-container {
  @apply border-t border-b border-gray-200;
}

.ag-menu {
  @apply shadow-md bg-blue-500 rounded;
}
.ag-select .ag-picker-field-wrapper {
  @apply p-2 font-normal text-base rounded mb-1 cursor-pointer bg-blue-400 text-blue-50;
}
.ag-select-list {
  @apply p-2 font-normal text-base cursor-pointer bg-blue-50 text-blue-700 rounded-b;
  overflow-y: auto;
  overflow-x: hidden;
}
.ag-list-item {
  overflow: hidden;
  text-overflow: ellipsis;
  @apply hover:bg-blue-200 border-none p-2 rounded-md outline-none;
}
.ag-list-item.ag-active-item {
  /* background-color: rgba(33, 150, 243, 0.1); */
}
.ag-select-list-item {
}
.ag-select-list-item span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ag-filter-condition {
  @apply p-2;
}
.ag-ltr .ag-filter-condition-operator {
  @apply space-x-4 text-white;
}
.ag-radio-button-input-wrapper {
  font-family: 'agGridAlpine';
  font-size: 16px;
  line-height: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 3px;
  display: inline-block;
  vertical-align: middle;
  flex: none;
  border-radius: 16px;
  @apply mr-2;
}
.ag-radio-button-input-wrapper input,
.ag-radio-button-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-radio-button-input-wrapper:focus-within,
.ag-radio-button-input-wrapper:active {
  outline: none;
}
.ag-radio-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-radio-button-input-wrapper::after {
  content: '\f124';
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  @apply text-blue-500;
}
.ag-radio-button-input-wrapper.ag-checked::after {
  content: '\f125';
  @apply text-blue-500;
}

.ag-header-cell.ag-column-menu-visible .ag-header-icon.ag-header-cell-menu-button,
.ag-header-cell.ag-column-menu-visible .ag-icon-menu {
  @apply text-teal-200 opacity-100;
}
.ag-header-cell-resize {
  display: flex;
  align-items: center;
}
.ag-header-cell-resize::after {
  content: '';
  position: absolute;
  z-index: 1;
  display: block;
  left: calc(50% - 1px);
  width: 2px;
  height: 32%;
  top: calc(34%);
  background-color: rgba(186, 191, 199, 0.5);
  @apply bg-blue-400;
}
.ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 2px);
}

.ag-dnd-ghost {
  @apply bg-blue-500 text-white pl-8 pr-12;
  border-radius: 3px;
  box-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 10;
  height: 48px !important;
  line-height: 48px;
  margin: 0;
  -webkit-transform: translateY(12px);
  transform: translateY(12px);
}
.ag-dnd-ghost-icon {
  margin-right: 6px;
  color: #fff;
}
</style>
